import React from 'react';
import { OFFER_ANCHOR, SUPPORT_EMAIL } from './constants';
export function Footer() {
  return <footer className="bg-eq-deep px-3 py-2.5 text-center text-white/70 sm:px-4" data-id="element-58" data-mp="3gfsoqi9xf4pm">
      <p className="font-display text-[10.5px] font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-59" data-mp="32o4bgbnxya72">
        © 2026 HORSE RIDING INSTRUCTOR PRO™ — All Rights Reserved.
      </p>
      <p className="mx-auto mt-0.5 max-w-3xl text-[10.5px] font-medium leading-snug sm:text-xs" data-id="element-60" data-mp="36n3bpiyq9is6">
        This system is designed for professional development. Instructors remain responsible for
        adapting activities, horse-rider combinations, progression, and teaching decisions to each
        rider, horse, environment, and safety context.
      </p>
      <nav className="mt-1 flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[10.5px] font-bold sm:text-xs" data-id="element-61" data-mp="3qc40n75ltsjj">
        <a href={OFFER_ANCHOR} className="transition-colors duration-150 ease-out hover:text-eq-goldLight" data-id="element-62" data-mp="2a19tpmiidoxa">
          Terms &amp; Conditions
        </a>
        <span aria-hidden="true" data-id="element-63" data-mp="3la29euiur3v8">•</span>
        <a href={OFFER_ANCHOR} className="transition-colors duration-150 ease-out hover:text-eq-goldLight" data-id="element-64" data-mp="3gah0psdvrh5b">
          Privacy Policy
        </a>
        <span aria-hidden="true" data-id="element-65" data-mp="3v5n5yd55jbxl">•</span>
        <a href={OFFER_ANCHOR} className="transition-colors duration-150 ease-out hover:text-eq-goldLight" data-id="element-66" data-mp="3q83tnis0l98a">
          Contact
        </a>
      </nav>
      <p className="mt-0.5 text-[10.5px] font-medium sm:text-xs" data-id="element-67" data-mp="33xdnwzdzwrz">
        Support:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="font-bold text-eq-goldLight transition-colors duration-150 ease-out hover:text-white" data-id="element-68" data-mp="3232vbhtxl1m">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </footer>;
}